angular.module('lsnBase.constants', []);